import { useEffect } from 'react';

const DEFAULT_FAVICON = '/favicon-house.png';

export function useDynamicFavicon(faviconUrl: string | null | undefined) {
  useEffect(() => {
    const favicon = faviconUrl || DEFAULT_FAVICON;
    
    // Update all favicon-related links to ensure consistency
    const selectors = [
      "link[rel='icon']",
      "link[rel='shortcut icon']",
      "link[rel='apple-touch-icon']"
    ];
    
    selectors.forEach(selector => {
      let link = document.querySelector<HTMLLinkElement>(selector);
      
      if (!link) {
        link = document.createElement('link');
        link.rel = selector.match(/rel='([^']+)'/)?.[1] || 'icon';
        document.head.appendChild(link);
      }
      
      link.type = 'image/png';
      link.href = favicon;
    });
  }, [faviconUrl]);
}
